module.exports = __webpack_public_path__ + "img/loading_green.c0f9be04.gif";